export const version = '5.11.2';
//# sourceMappingURL=version.js.map